module.exports = __webpack_public_path__ + "db77dbfb1ae471330e102263f698450a.svg";